import React from "react";

function ExitButton({ handler }) {
  return (
    <button className="close-button" title="Exit" onClick={handler}>
      <i className="fa fa-times fa-sm"></i>
    </button>
  );
}

export default ExitButton;